import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree/dist/core/type/type';

import { AdmissionAccessMode, AdmissionPeriodType } from '@/enums/admissions';
import { ProjectModel } from '@/models/projects';
import { edges, nullOrUndefined } from '@/models/utils';
import { BaseModel } from '@/stores/shared';

export const AdmissionStatsModel = types
  .model({
    appliedProjects: types.number,
    applicationsLimit: types.number,
  })
  .actions((self) => ({
    increaseAppliedCounter() {
      self.appliedProjects += 1;
    },
    decreaseAppliedCounter() {
      self.appliedProjects -= 1;
    },
  }));

export const AdmissionLifecyclePeriodModel = types.model({
  id: types.maybe(types.string),
  periodType: types.enumeration<AdmissionPeriodType>(
    Object.values(AdmissionPeriodType),
  ),
  title: types.maybe(types.string),
  active: types.maybe(types.boolean),
  start: types.maybe(types.string),
  end: types.maybe(types.string),
});

export type AdmissionLifecyclePeriodModelType = Instance<
  typeof AdmissionLifecyclePeriodModel
> & {};

export const AdmissionModel = types.compose(
  BaseModel,
  types.model({
    title: types.maybe(types.string),
    isOpenForStudentApplication: types.maybe(types.boolean),
    isOpenForProjectSubmission: nullOrUndefined(types.boolean),
    allowDeleteInprogressApplications: types.maybe(types.boolean),
    interviewOnlyProjectsAllowed: types.maybe(types.boolean),
    studentApplicationDeadline: types.maybe(types.string),
    description: types.maybe(types.frozen()),
    status: types.maybe(types.string),
    isOver: types.maybe(types.boolean),
    stats: nullOrUndefined(AdmissionStatsModel),
    lifecyclePeriods: types.maybe(edges(AdmissionLifecyclePeriodModel)),
    projects: types.late(() => types.maybe(edges(ProjectModel))),
    accessMode: types.maybe(
      types.enumeration<AdmissionAccessMode>(
        Object.values(AdmissionAccessMode),
      ),
    ),
  }),
);

export type AdmissionModelType = Instance<typeof AdmissionModel> & {};
